import { useRef } from "react"
import { Dayjs } from "dayjs"
import styled from "styled-components"

import { useOutsideClick } from "utils/useOutsideClick"
import DateWithSelectTimePicker from "components/common/DateWithSelectTimePicker.tsx/DateWithSelectTimePicker"
import { ButtonNew } from "components/form/ButtonNew"

const Container = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  border-radius: 8px;
  width: 290px;
  top: 42px;
  left: 0;
  background-color: #fff;
  z-index: 10;
  box-shadow:
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);

  @media only screen and (max-width: 820px) {
    left: auto;
    right: 5px;
    top: 110px;
  }
`

const Description = styled.div`
  color: #64748b;
  padding: 0 18px;
  font-size: 12px;
  margin-bottom: 10px;
`

const BottomContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 10px 18px 0;
  margin-bottom: 10px;
  gap: 8px;
  border-top: 1px solid #eaeaea;

  span {
    flex: 1;
  }
`

interface MessageScheduleDateTimePickerProps {
  onCancel: () => void
  onSubmit: () => void
  selectedDateTime: Dayjs | null
  onDateTimeChange: (dateTime: Dayjs) => void
}

const MessageScheduleDateTimePicker = ({
  onCancel,
  onSubmit,
  selectedDateTime,
  onDateTimeChange,
}: MessageScheduleDateTimePickerProps) => {
  const container = useRef<HTMLDivElement>(null)

  useOutsideClick(container, () => onCancel(), true)

  return (
    <Container ref={container}>
      <DateWithSelectTimePicker onDateTimeChange={onDateTimeChange} />
      {selectedDateTime && (
        <Description>
          Message will be sent to the customer on {selectedDateTime.format("MMMM DD, YYYY hh:mm A")}
        </Description>
      )}
      <BottomContainer>
        <ButtonNew color="white" onClick={onCancel}>
          Cancel
        </ButtonNew>
        <ButtonNew color="blue" onClick={onSubmit} disabled={!selectedDateTime}>
          Schedule
        </ButtonNew>
      </BottomContainer>
    </Container>
  )
}

export default MessageScheduleDateTimePicker
